import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import UserInfoItemListViewModel from './UserInfoItemListViewModel'
import styles from './UserInfoItemListDialog.sass'

interface UserInfoItemListDialogProps {
  vm: UserInfoItemListViewModel
}

export default observer(function UserInfoItemListDialog({
  vm,
}: UserInfoItemListDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>
          {vm.title}
          <span className={styles.titleSubtext}>
            {` (${vm.userInfoItems.length})`}
          </span>
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        {vm.userInfoItems.map((item, index) => (
          <UserInfoItem
            key={index}
            item={item}
            data-test={`user-info-item-${vm.normalizeString(vm.title)}-${vm.normalizeString(item)}-value`}
          />
        ))}
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            dataTest={`user-details-pro-information-${vm.normalizeString(vm.title)}-close-button`}
          >
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface UserInfoItemProps {
  item: string
  'data-test'?: string
}

const UserInfoItem = observer(
  ({ item, 'data-test': dataTest }: UserInfoItemProps) => {
    return (
      <div className={styles.userInfoItem}>
        <span className={styles.userInfoItemName} data-test={dataTest}>
          {item}
        </span>
      </div>
    )
  },
)
